/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: EmployeesModule
 * Purpose		: Module for Employees.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { EmployeesService } from './Employees.service';
import { EmployeesListComponent } from './EmployeesList.component';
import { EmployeesSearchComponent } from './EmployeesSearch.component';
import { EmployeesAddComponent } from './EmployeesAdd.component';
import { EmployeesEditComponent } from './EmployeesEdit.component';
import { EmployeesDetailsComponent } from './EmployeesDetails.component';

import { EmployeesRoutingModule } from './Employees-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    EmployeesRoutingModule
  ],
  declarations: [
    EmployeesListComponent,
	EmployeesSearchComponent,
    EmployeesEditComponent,
    EmployeesAddComponent,
	EmployeesDetailsComponent
  ],
  providers: [
    EmployeesService
  ]
})

export class EmployeesModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Employees/Employees.module.ts